import { CheckIcon } from "lucide-react";

interface ChatQuizResultCardProps {
	score: number;
	total: number;
}

const ChatQuizResultCard = ({ score, total }: ChatQuizResultCardProps) => {
	return (
		<div className="flex w-full flex-col gap-3 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-700 dark:bg-slate-800">
			<div className="flex items-center gap-3">
				<div className="flex size-10 items-center justify-center rounded-full bg-emerald-100 text-emerald-600 dark:bg-emerald-900/30 dark:text-emerald-400">
					<CheckIcon className="size-5" />
				</div>
				<div>
					<h4 className="font-semibold text-slate-900 dark:text-white">
						Quiz Attempt Submitted
					</h4>
					<p className="text-slate-500 text-xs dark:text-slate-400">
						You scored {score} out of {total}
					</p>
				</div>
			</div>
		</div>
	);
};

export default ChatQuizResultCard;
